import { createConfigSelector } from '@americanexpress/travel-selectors';
import { featureFlagConfig } from '@/constants';

export const getFaasApiUrl = createConfigSelector('faasApiUrl');

export const getLoginUrl = createConfigSelector('loginUrl');

export const getNewDomainUrl = createConfigSelector('newDomainUrl');

export const getCulinaryCollectiveFlags = createConfigSelector(
  'culinaryCollectiveEnabled'
);

export const getAccessFlags = createConfigSelector('accessEnabled');

export const getDigitalWaitlistFlags = createConfigSelector(
  'digitalWaitlistEnabled'
);

export const getLocationMapFlags = createConfigSelector('locationMapEnabled');

export const getCenturionNetworkFlags = createConfigSelector(
  'centurionNetworkEnabled'
);

export const getProxyUrl = createConfigSelector('proxyUrl');

export const getUpdatedHeaderFlag = createConfigSelector(
  'updatedHeaderEnabled'
);

export const getEnabledMarkets = createConfigSelector('enabledMarkets');

export const getGLCBannerFlags = createConfigSelector(
  featureFlagConfig.GLC_BANNER_ENABLED
);

export const getFeaturedLocationFlags = createConfigSelector(
  'featuredLocationEnabled'
);

export const getUpdatedPartnersAndProgramsFlags = createConfigSelector(
  featureFlagConfig.UPDATED_PROGRAMS_AND_PARTNERS_ENABLED
);
